import moment from 'moment';

import '../../sass/components/common/Milestone.scss';
const Milestone = ({
  type,
  role,
  company,
  start_date,
  end_date,
  business_expertise,
  countries_regions,
  details,
  isLast,
}) => {
  return (
    <div className="milestone-container">
      {/* Left indicator and the dashed border */}
      <div className="milestone-container-left">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12.0002"
            cy="12.0002"
            r="9.85714"
            fill="#F26E26"
            stroke="white"
            strokeWidth="4"
          />
          <circle cx="12" cy="12" r="10.5" stroke="#F26E26" />
        </svg>

        {!isLast && type === 'work' && <div className="dashed-line-vert"></div>}
      </div>
      {/* Right side content */}
      {type === 'work' && (
        <div className="milestone-container-right">
          <span className="role-label">{role}</span>
          <span className="company-label">{company}</span>
          <span className="company-label">{`${moment(
            start_date,
            'DD.MM.YYYY'
          ).format('MMMM YYYY')} - ${
            end_date
              ? moment(end_date, 'DD.MM.YYYY').format('MMMM YYYY')
              : 'Present'
          }`}</span>
          <span className="company-label">{details}</span>
        </div>
      )}
      {type === 'business' && (
        <div className="milestone-container-right">
          <span className="role-label">{business_expertise}</span>
          <span className="company-label">
            <svg
              width="16"
              height="14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 13.5 }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.19126.0518955C6.02614.110433 5.84903.274821 5.76181.450532c-.05608.112957-.06498.219008-.07428.883738l-.01052.75537h.73495V.695106h2.85547V2.08964H9.93597l-.01052-.75537C9.91369.49363 9.89971.431175 9.67397.211935 9.45785.00205775 9.41764-.00245798 7.79228.0004639c-1.19794.0021582-1.4883.0114883-1.60102.0514316ZM.509735 2.16717c-.161899.0587-.330903.20698-.4147408.3639-.073711.13786-.0747735.15821-.0848008 1.62546L0 5.64237h6.37749l.0181-.09131c.03865-.19487.17033-.38887.3324-.48975l.16-.0996.87905-.00987.87902-.00989.17957.08785c.19875.09726.31433.24285.3742.47146l.03695.14111H15.613l-.0102-1.48584c-.01-1.4619-.0114-1.48806-.0839-1.62373-.0906-.16934-.27-.32161-.4383-.37208-.1852-.05544-14.417533-.04917-14.570865.00645ZM7.10922 6.35624v.71386h1.39454V5.64237H7.10922v.71387ZM.0112559 9.63504c.008666 3.10956.0119863 3.26766.0709883 3.37846.0993108.1864.2201368.2939.4103248.3651.17581.0658.255597.0665 7.313921.0665 7.05831 0 7.13811-.0007 7.31391-.0665.1902-.0712.311-.1787.4103-.3651.059-.1108.0624-.2691.0712-3.37846l.0092-3.2622H9.24193l-.01308.43994c-.01166.39193-.02205.45608-.09517.58789-.04515.08135-.14685.19341-.22604.24903l-.14397.10107H6.84931l-.14397-.10107c-.07919-.05562-.18132-.16768-.22698-.24903-.07464-.13308-.08417-.19224-.09456-.58789l-.01155-.43994H.00219141l.00906449 3.2622Z"
                fill="#F26E26"
              />
            </svg>
            {company}
          </span>
          <span className="company-label">
            <svg
              width="12"
              height="15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 17 }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.44374.00991426C4.54407.0848531 3.57619.381348 2.80243.819073 2.06908 1.23393 1.42499 1.80635.962781 2.45404.491259 3.11473.148705 3.92602.0563081 4.60073c-.0711033.51938-.0755054 1.25601-.0095706 1.60715C.147498 6.7446.35921 7.35998.597026 7.80737c.088125.16578.395657.60704 1.493414 2.14286 1.96929 2.75507 3.4071 4.74017 3.5353 4.88087.09905.1087.21279.1549.3805.1546.14452-.0003.22521-.0294.30341-.1093.16772-.1715 4.32635-5.99442 4.91005-6.87506.3519-.53095.6025-1.21985.7053-1.93887.0369-.25787.0494-.77622.0254-1.05613-.1406-1.64486-1.0733-3.10457-2.59362-4.05894C8.54688.438976 7.68401.145251 6.66657.0316184 6.40411.00230711 5.68775-.010397 5.44374.00991426ZM6.38939.958007c.3376.021612.50182.042063.7337.091373 1.19581.2543 2.31448.95411 3.00441 1.87949.4274.57322.7002 1.2233.7979 1.90145.0327.22708.027.9863-.0092 1.21684-.0607.38732-.1566.70646-.3148 1.0476-.1096.23648-.1084.23458-.4638.75087-.86186 1.2525-4.03406 5.70257-4.13813 5.80527-.02962.0292.0144.0893-2.44552-3.3405-.67161-.93646-1.78939-2.51998-1.98292-2.80916-.53027-.79235-.716771-2.06225-.45517-3.09949.34652-1.37403 1.46205-2.56324 2.9257-3.11899.43054-.16347.96941-.290314 1.40218-.330064.13133-.012061.7266-.008725.94565.005311ZM5.67705 2.82565c-.29342.02899-.64527.12545-.94255.25841-.60902.27237-1.05729.69054-1.33872 1.24881-.39663.7868-.30805 1.77619.22339 2.4949.4132.55882 1.09844.96452 1.85323 1.09723.25399.04464.72806.0476.9734.00606.93023-.1575 1.67017-.66204 2.06795-1.41002.11822-.22231.19712-.42462.24175-.61995.04974-.21771.05419-.7361.00833-.97128-.07357-.37713-.22763-.70211-.49706-1.04847-.56074-.72087-1.61765-1.15172-2.58972-1.05569Zm.74495.97827c.57254.15435.97992.45957 1.22146.91516.24976.47109.22042 1.0264-.0783 1.48128-.62903.95792-2.05656 1.11289-2.90599.31547-.22046-.20696-.42758-.53756-.4708-.7515-.022-.10888-.02089-.65187.00155-.75341.02393-.10835.14129-.3401.24965-.493.0992-.13995.34329-.36907.49058-.4605.20891-.12965.46101-.2285.70308-.27566.17328-.03376.62878-.02095.78877.02216Z"
                fill="#F26E26"
              />
            </svg>
            {countries_regions}
          </span>
          <span className="company-label">{details}</span>
        </div>
      )}
    </div>
  );
};
export default Milestone;
